import {
  MediaData,
  NumberMediaData,
  SentenceDragAndDropData,
  SentenceDragAndDropNodeData,
} from '../../../types/quiz';
import { getQuestion, parseMainExp } from './utils';

/**
 * SentenceDragAndDrop.
 */
export const mapSentenceDragAndDrop = ({
  data,
  mediaData,
}: {
  data: SentenceDragAndDropNodeData;
  mediaData: MediaData<NumberMediaData[]>;
}): SentenceDragAndDropData => {
  return {
    question: getQuestion<NumberMediaData[]>(data.q, mediaData),
    mainExplanation: parseMainExp<NumberMediaData[]>(data.e, mediaData) || '',
    keyTakeaway: parseMainExp<NumberMediaData[]>(data.kp, mediaData) || '',
    answers: data.a,
    distractors: data.distractors,
  };
};
